import { Helmet } from 'react-helmet-async';
import AdminScrapping from 'src/sections/overview/dashboards/views/admin/scrapping/scraping';

export default function BrandShieldScraping() {
  return (
    <>
      <Helmet>
        <title>Scraping</title>
      </Helmet>

      <AdminScrapping />
    </>
  );
}
